import {
  Box,
  Button,
  Text,
  Flex,
  VStack,
  HStack,
  Badge,
  Avatar,
  Divider,
  Icon,
  IconButton,
  Image,
  useColorModeValue,
  useToast,
  Input,
  InputGroup,
  InputLeftElement,
  SimpleGrid,
  Progress,
  Select,
  Card,
  CardBody,
  Modal,

  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  useDisclosure,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
} from "@chakra-ui/react";
import {
  MdArrowBack,
  MdArrowForward,
  MdLocationOn,
  MdCalendarToday,
  MdPerson,
  MdDirectionsCar,
  MdMoreVert,
  MdSearch,
  MdGridView,
  MdList,
  MdTableChart,
  MdChevronLeft,
  MdChevronRight,
  MdAdd,
  MdRemove,
  MdWarning,
  MdCheckCircle,
  MdError,
  MdRefresh,
  MdLocalHospital,
  MdLocalPharmacy,
  MdMedicalServices,
  MdDelete,
} from "react-icons/md";
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getVehicule, getUsers, getMaintenanceTasks, getMateriels, getMaterielsByAmbulanceId, getOxygenBottles, createDispatch, updateMaintenanceTask, createMaintenanceTask, createMateriel, deleteMateriel, updateMateriel, patchMateriel, incrementMateriel, decrementMateriel, getUtilisationMaterielByAmbulanceId, getVehicleMaintenanceHistory, getAllStock, assignStockToAmbulance, createMaintenanceTaskHistory,getUser } from "../../../api/api";
import GoogleMapsLoader from "components/GoogleMapsLoader";
import axios from "axios";
import config from "config/api";
import LoadingSpinner from "components/LoadingSpinner";
import dayjs from 'dayjs';
import ambulanceImg from "assets/img/ambulance.png";

const normalizeType = (value = "") =>
  value
    .toString()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();

/** Consommable, dispositif, pharmacie — types non reconnus regroupés en consommable */
const getMaterielCategoryKey = (type) => {
  const t = normalizeType(type);
  if (!t) return "consommable";
  if (t.includes("pharmacie")) return "pharmacie";
  if (t.includes("consommable")) return "consommable";
  if (t.includes("dispositif")) return "dispositif";
  if (t === "medical_device" || t === "medical") return "dispositif";
  return "consommable";
};

const VehicleDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [vehicle, setVehicle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [ambulancier, setAmbulancier] = useState(null);
  const [maintenanceTasks, setMaintenanceTasks] = useState([]);
  const [activeTab, setActiveTab] = useState("maintenance");
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [sortBy, setSortBy] = useState("latest");
  const [viewMode, setViewMode] = useState("grid");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [fuelLevel, setFuelLevel] = useState(null);
  const [km, setKm] = useState(null);
  const [oxygenBottles, setOxygenBottles] = useState([]);

  const [materials, setMaterials] = useState([]);
  const [stock, setStock] = useState([]);
  const [loadingInventory, setLoadingInventory] = useState(false);
  /** Recherche locale par carte inventaire (oxygène + catégories matériel) */
  const [inventoryCardSearch, setInventoryCardSearch] = useState({
    oxygene: "",
    consommable: "",
    dispositif: "",
    pharmacie: "",
  });
  const [vehicleLocation, setVehicleLocation] = useState(null);
  const [showAddMaterialModal, setShowAddMaterialModal] = useState(false);
  const [materialHistory, setMaterialHistory] = useState([]); // Pour l'historique de consommation
  const [maintenanceHistory, setMaintenanceHistory] = useState([]); // Pour l'historique de maintenance
  const [loadingHistory, setLoadingHistory] = useState(false);

  // Modal state
  const {
    isOpen: isAddMaterialOpen,
    onOpen: onAddMaterialOpen,
    onClose: onAddMaterialClose
  } = useDisclosure();

  // Modal state for maintenance tasks
  const {
    isOpen: isAddMaintenanceOpen,
    onOpen: onAddMaintenanceOpen,
    onClose: onAddMaintenanceClose
  } = useDisclosure();

  const [newMaterialData, setNewMaterialData] = useState([
    { type: "", item: "", quantite: 1, stock_id: "" }
  ]);

  // State for new maintenance task
  const [newMaintenanceTask, setNewMaintenanceTask] = useState({
    name: "",
    description: "",
    status: "ok"
  });
  // Inventaire médical par défaut
  // const defaultMedicalDevices = [
  //   { name: 'Moniteur multiparamétrique de transport', quantity: 1, category: 'medical' },
  //   { name: 'Pousses seringues électriques ', quantity: 1, category: 'medical' },
  //   { name: 'Défibrillateurs externes semi-automatiques et Sac de transport. ', quantity: 1, category: 'medical' },
  //   { name: 'Aspirateur électrique de mucosités avec batterie ', quantity: 1, category: 'medical' },
  //   { name: 'laryngoscope', quantity: 1, category: 'medical' },
  //   { name: 'réanima adulte', quantity: 1, category: 'medical' }, 
  //   { name: 'réanima  pédiatrique', quantity: 1, category: 'medical' },
  //   { name: 'Minerves Adultes ', quantity: 1, category: 'medical' },
  //   { name: 'BRANCARD CUILLERE DE TRANSPORT EN ALUMIUM', quantity: 1, category: 'medical' }, 
  //   { name: 'Inventaire d’immobilisation', quantity: 1, category: 'medical' }, 
  //   { name: 'Chaise pliable', quantity: 1, category: 'medical' }, 
  //   { name: 'Stéthoscope', quantity: 1, category: 'medical' }, 
  //   { name: 'Thermomètre à infrarouge', quantity: 1, category: 'medical' }, 
  //   { name: 'Glucomètre ', quantity: 1, category: 'medical' }, 
  //   { name: 'RESPIRATEUR', quantity: 1, category: 'medical' }, 
  //   { name: 'TRANSFORMATION', quantity: 1, category: 'medical' }, 
  // ];

  // Fonction pour obtenir les dispositifs médicaux (uniquement les éléments par défaut)
  // const getCombinedMedicalDevices = () => {
  //   return defaultMedicalDevices.map((item, index) => ({
  //     id: `default-${index}`,
  //     name: item.name,
  //     quantity: item.quantity,
  //     category: item.category
  //   }));
  // };

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [map, setMap] = useState(null);
  const [marker, setMarker] = useState(null);
  const [dispatchDescription, setDispatchDescription] = useState("");
  const mapRef = React.useRef(null);

  const bgCard = useColorModeValue("white", "gray.700");
  const borderColor = useColorModeValue("gray.200", "gray.600");
  const bgColor = useColorModeValue("gray.50", "gray.800");
  const inventorySearchInputBg = useColorModeValue("white", "gray.800");

  // Fetch vehicle location from Navixy
  const fetchVehicleLocation = async (trackerId) => {
    if (!trackerId) return null;

    try {
      const data = {
        // Utiliser le hash depuis la config (variable d'environnement)
        hash: config.navixy.hash,
        tracker_id: trackerId,
      };
      const response = await axios.post(
        `${config.navixy.apiUrl}/tracker/get_state`,
        data,
        {
          headers: { 'Content-Type': 'application/json' },
          // Ne pas envoyer de cookies/credentials vers Navixy pour éviter les erreurs CORS
          withCredentials: false,
        }
      );

      return {
        lat: response.data.state.gps.location.lat,
        lng: response.data.state.gps.location.lng
      };
    } catch (error) {
      console.error('Error fetching vehicle location:', error);
      return null;
    }
  };

  // Fetch vehicle diagnostics from Navixy
  const fetchVehicleData = async (trackerId) => {
    if (!trackerId) return null;

    try {
      const data = {
        // Utiliser le hash depuis la config (variable d'environnement)
        hash: config.navixy.hash,
        tracker_id: trackerId,
      };
      const diagnosticsRes = await axios.post(
        `${config.navixy.apiUrl}/tracker/get_diagnostics`,
        data,
        {
          headers: { 'Content-Type': 'application/json' },
          // Ne pas envoyer de cookies/credentials vers Navixy pour éviter les erreurs CORS
          withCredentials: false,
        }
      );

      const inputs = diagnosticsRes.data.inputs;
      const gas = inputs.find(input => input.type === "fuel")?.value;
      const kmValue = inputs.find(input => input.type === "custom")?.value;

      return { gas, km: kmValue };
    } catch (error) {
      console.error('Error fetching vehicle data:', error);
      return null;
    }
  };

  async function loadHistoryData() {
    setLoadingHistory(true);
    try {
      const [matRes, mainRes] = await Promise.all([
        getUtilisationMaterielByAmbulanceId(id),
        getVehicleMaintenanceHistory(id)
      ]);
      setMaterialHistory(matRes.data || []);
      setMaintenanceHistory(mainRes.data || []);
    } catch (error) {
      console.error("Error fetching history:", error);
    } finally {
      setLoadingHistory(false);
    }
  }

  useEffect(() => {
    if (activeTab === "Historique") {
      loadHistoryData();
    }
  }, [activeTab, id]);

  useEffect(() => {
    const fetchVehicleDetails = async () => {
      try {
        const vehicleRes = await getVehicule(id);
        const vehicleData = vehicleRes.data;
        setVehicle(vehicleData);

        // Fetch users to get ambulancier info
        const usersRes = await getUsers();
        const usersList = usersRes.data || [];

        if (vehicleData.user_id) {
          const ambulancierData = usersList.find(u => u.id == vehicleData.user_id);
          setAmbulancier(ambulancierData);
        }

        // Fetch maintenance tasks
        const tasksRes = await getMaintenanceTasks(id);
        setMaintenanceTasks(tasksRes.data || []);

        // Fetch inventory data
        try {
          const oxygenRes = await getOxygenBottles(id);
          setOxygenBottles(oxygenRes.data || []);
        } catch (error) {
          console.error("Error fetching oxygen bottles:", error);
        }

        try {
          const materialsRes = await getMaterielsByAmbulanceId(id);
          setMaterials(materialsRes.data || []);
        } catch (error) {
          console.error("Error fetching materials:", error);
        }

        // Fetch vehicle diagnostics if tracker_id exists
        if (vehicleData.tracker_id) {
          const [diagnostics, location] = await Promise.all([
            fetchVehicleData(vehicleData.tracker_id),
            fetchVehicleLocation(vehicleData.tracker_id)
          ]);

          if (diagnostics) {
            setFuelLevel(diagnostics.gas);
            setKm(diagnostics.km || vehicleData.km);
          } else {
            setKm(vehicleData.km);
          }

          if (location) {
            setVehicleLocation(location);
            setSelectedLocation(location);
          }
        } else {
          setKm(vehicleData.km);
        }

        // Fetch stock
        try {
          const stockRes = await getAllStock();
          setStock(stockRes.data || []);
        } catch (error) {
          console.error("Error fetching stock:", error);
        }
      } catch (error) {
        console.error("Error fetching vehicle details:", error);
        toast({
          title: "Erreur",
          description: "Impossible de charger les détails du véhicule",
          status: "error",
          isClosable: true,
        });
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      fetchVehicleDetails();
    }
  }, [id, toast]);

  // Initialize Google Maps when location is available
  useEffect(() => {
    if (window.google && window.google.maps && vehicleLocation && mapRef.current && activeTab === "localisation") {
      const initialLocation = { lat: vehicleLocation.lat, lng: vehicleLocation.lng };

      // Clean up existing map and markers
      if (map) {
        // Clear all markers
        if (marker) {
          marker.setMap(null);
        }
        // Reset map reference
        setMap(null);
        setMarker(null);
      }

      // Small delay to ensure cleanup is complete
      const timer = setTimeout(() => {
        if (mapRef.current) {
          const newMap = new window.google.maps.Map(mapRef.current, {
            center: initialLocation,
            zoom: 13,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            styles: [
              { "elementType": "geometry", "stylers": [{ "color": "#ebe3cd" }] },
              { "elementType": "labels.text.fill", "stylers": [{ "color": "#523735" }] },
              { "elementType": "labels.text.stroke", "stylers": [{ "color": "#f5f1e6" }] },
              { "featureType": "administrative", "elementType": "geometry.stroke", "stylers": [{ "color": "#c9b2a6" }] },
              { "featureType": "administrative.land_parcel", "elementType": "geometry.stroke", "stylers": [{ "color": "#dcd2be" }] },
              { "featureType": "administrative.land_parcel", "elementType": "labels.text.fill", "stylers": [{ "color": "#ae9e90" }] },
              { "featureType": "landscape.natural", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
              { "featureType": "poi", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
              { "featureType": "poi", "elementType": "labels.text.fill", "stylers": [{ "color": "#93817c" }] },
              { "featureType": "poi.park", "elementType": "geometry.fill", "stylers": [{ "color": "#006133" }] },
              { "featureType": "poi.park", "elementType": "labels.text.fill", "stylers": [{ "color": "#447530" }] },
              { "featureType": "road", "elementType": "geometry", "stylers": [{ "color": "#f5f1e6" }] },
              { "featureType": "road.arterial", "elementType": "geometry", "stylers": [{ "color": "#fdfcf8" }] },
              { "featureType": "road.highway", "elementType": "geometry", "stylers": [{ "color": "#f8c967" }] },
              { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "color": "#e9bc62" }] },
              { "featureType": "road.highway.controlled_access", "elementType": "geometry", "stylers": [{ "color": "#e98d58" }] },
              { "featureType": "road.highway.controlled_access", "elementType": "geometry.stroke", "stylers": [{ "color": "#db8555" }] },
              { "featureType": "road.local", "elementType": "labels.text.fill", "stylers": [{ "color": "#806b63" }] },
              { "featureType": "transit.line", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
              { "featureType": "transit.line", "elementType": "labels.text.fill", "stylers": [{ "color": "#8f7d77" }] },
              { "featureType": "transit.line", "elementType": "labels.text.stroke", "stylers": [{ "color": "#ebe3cd" }] },
              { "featureType": "transit.station", "elementType": "geometry", "stylers": [{ "color": "#dfd2ae" }] },
              { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#b9d3c2" }] },
              { "featureType": "water", "elementType": "labels.text.fill", "stylers": [{ "color": "#92998d" }] }
            ],
          });

          // Create vehicle marker with custom icon (red badge style with arrow)
          const vehicleLabel = vehicle?.immatriculation || `AMB-${id}`;
          const svgMarker = `
            <svg width="49" height="37" viewBox="0 0 49 37" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect width="49" height="26" rx="6" fill="#F8285A"/>
              <text x="50%" y="13" dominant-baseline="middle" text-anchor="middle" fill="white" font-family="Arial, sans-serif" font-size="11" font-weight="400">${vehicleLabel}</text>
              <polygon points="24.5,26 14,37 35,37" fill="#F8285A"/>
            </svg>
          `;
          const iconUrl = 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svgMarker);

          const vehicleMarker = new window.google.maps.Marker({
            position: initialLocation,
            map: newMap,
            title: vehicleLabel,
            icon: {
              url: iconUrl,
              scaledSize: new window.google.maps.Size(49, 37),
              anchor: new window.google.maps.Point(24.5, 37),
            },
            zIndex: 1000,
          });

          // Create draggable dispatch marker
          const dispatchMarker = new window.google.maps.Marker({
            position: initialLocation,
            map: newMap,
            draggable: true,
            title: "Point de dispatch",
            icon: {
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 8,
              fillColor: '#F8285A',
              fillOpacity: 1,
              strokeColor: '#FFFFFF',
              strokeWeight: 2,
            },
          });

          dispatchMarker.addListener("dragend", (e) => {
            const position = e.latLng;
            setSelectedLocation({ lat: position.lat(), lng: position.lng() });
          });

          // Allow clicking on map to move dispatch marker
          newMap.addListener("click", (e) => {
            const position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
            dispatchMarker.setPosition(e.latLng);
            setSelectedLocation(position);
          });

          setMap(newMap);
          setMarker(dispatchMarker);

          // Forcer le recalcul du viewport après rendu pour éviter une carte grise
          setTimeout(() => {
            try {
              window.google.maps.event.trigger(newMap, "resize");
              newMap.setCenter(initialLocation);
              newMap.setZoom(13);
            } catch (e) {
              // ignore
            }
          }, 120);
        }
      }, 100);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [vehicleLocation, activeTab, vehicle, id]);

  // Quand l'onglet localisation devient visible, forcer resize + center.
  useEffect(() => {
    if (
      activeTab === "localisation" &&
      map &&
      vehicleLocation &&
      window.google &&
      window.google.maps
    ) {
      const timer = setTimeout(() => {
        try {
          window.google.maps.event.trigger(map, "resize");
          map.setCenter({ lat: vehicleLocation.lat, lng: vehicleLocation.lng });
        } catch (e) {
          // ignore
        }
      }, 80);
      return () => clearTimeout(timer);
    }
  }, [activeTab, map, vehicleLocation]);

  // Filter and sort maintenance tasks
  const filteredTasks = React.useMemo(() => {
    let filtered = maintenanceTasks;

    // Filter by search term
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      filtered = filtered.filter(task =>
        task.name?.toLowerCase().includes(searchLower) ||
        task.notes?.toLowerCase().includes(searchLower)
      );
    }

    // Filter by status
    if (statusFilter !== "all") {
      filtered = filtered.filter(task => task.status === statusFilter);
    }

    // Sort
    if (sortBy === "latest") {
      filtered = [...filtered].sort((a, b) => {
        const dateA = new Date(a.next_due_date || 0);
        const dateB = new Date(b.next_due_date || 0);
        return dateB - dateA;
      });
    } else if (sortBy === "oldest") {
      filtered = [...filtered].sort((a, b) => {
        const dateA = new Date(a.next_due_date || 0);
        const dateB = new Date(b.next_due_date || 0);
        return dateA - dateB;
      });
    } else if (sortBy === "name") {
      filtered = [...filtered].sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortBy === "name_asc") {
      filtered = [...filtered].sort((a, b) => a.name.localeCompare(b.name));
    } else if (sortBy === "name_desc") {
      filtered = [...filtered].sort((a, b) => b.name.localeCompare(a.name));
    } else if (sortBy === "status_asc") {
      const statusOrder = { "ok": 1, "soon": 2, "urgent": 3 };
      filtered = [...filtered].sort((a, b) => statusOrder[a.status] - statusOrder[b.status]);
    } else if (sortBy === "status_desc") {
      const statusOrder = { "ok": 1, "soon": 2, "urgent": 3 };
      filtered = [...filtered].sort((a, b) => statusOrder[b.status] - statusOrder[a.status]);
    } else if (sortBy === "date_asc") {
      filtered = [...filtered].sort((a, b) => {
        const dateA = new Date(a.next_due_date || 0);
        const dateB = new Date(b.next_due_date || 0);
        return dateA - dateB;
      });
    } else if (sortBy === "date_desc") {
      filtered = [...filtered].sort((a, b) => {
        const dateA = new Date(a.next_due_date || 0);
        const dateB = new Date(b.next_due_date || 0);
        return dateB - dateA;
      });
    }

    return filtered;
  }, [maintenanceTasks, searchTerm, statusFilter, sortBy]);

  // Pagination
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const paginatedTasks = filteredTasks.slice(startIndex, endIndex);
  const totalPages = Math.ceil(filteredTasks.length / itemsPerPage);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "ok":
        return "#29BACD";
      case "soon":
        return "#F6B100";
      case "urgent":
        return "#F8285A";
      default:
        return "#656C7A";
    }
  };

  const getStatusBg = (status) => {
    switch (status?.toLowerCase()) {
      case "ok":
        return "#29BACD";
      case "soon":
        return "#F6B100";
      case "urgent":
        return "#F8285A";
      default:
        return "#656C7A";
    }
  };

  const handleStatusChange = async (taskId, newStatus) => {
    try {
      let userId = null;
      try {
        const user = await getUser();
        userId = user?.id ?? user?.user_id ?? null;
      } catch (e) {
        console.warn('Impossible de récupérer l\'utilisateur connecté:', e);
      }

      // Trouver la tâche actuelle pour récupérer l'ancien statut
      const currentTask = maintenanceTasks.find(t => t.id === taskId);
      const oldStatus = currentTask?.status || 'unknown';

      // Mettre à jour le statut
      await updateMaintenanceTask(id, taskId, { status: newStatus });

      // Enregistrer le changement dans l'historique
      try {
        await createMaintenanceTaskHistory(id, taskId, {
          action: 'status_change',
          from_status: oldStatus,
          to_status: newStatus,
          next_due_date_set: currentTask?.next_due_date || null,
          odometer_km: km ? parseInt(km) : null,
          cost_mad: null,
          notes: `Statut changé de "${oldStatus}" à "${newStatus}"`,
          user_id: userId
        });
      } catch (historyError) {
        console.error('Error creating maintenance history:', historyError);
        // On ne bloque pas si l'historique échoue
      }

      // Refresh tasks
      const tasksRes = await getMaintenanceTasks(id);
      setMaintenanceTasks(tasksRes.data || []);

      toast({
        title: "Statut mis à jour",
        status: "success",
        isClosable: true,
      });
    } catch (error) {
      console.error('Error updating status:', error);
      toast({
        title: "Erreur",
        description: error.response?.data?.message || "Impossible de mettre à jour le statut",
        status: "error",
        isClosable: true,
      });
    }
  };

  const handleDispatch = async () => {
    if (!selectedLocation || !dispatchDescription.trim()) {
      toast({
        title: "Erreur",
        description: "Veuillez sélectionner un point et saisir une description",
        status: "error",
        isClosable: true,
      });
      return;
    }

    try {
      const dispatchPayload = {
        ambulance_id: id,
        loc: `${selectedLocation.lat},${selectedLocation.lng}`,
        description: dispatchDescription
      };

      await createDispatch(dispatchPayload);

      toast({
        title: "Dispatch créé",
        description: "Le point de dispatch a été enregistré avec succès",
        status: "success",
        duration: 5000,
        isClosable: true,
      });

      setDispatchDescription("");
      setSelectedLocation(vehicleLocation);

      // Reset marker position
      if (marker && vehicleLocation) {
        marker.setPosition(new window.google.maps.LatLng(vehicleLocation.lat, vehicleLocation.lng));
      }
    } catch (err) {
      console.error('Dispatch Error:', err);
      toast({
        title: "Erreur",
        description: err.response?.data?.message || "Erreur lors de la création du dispatch",
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  };

  const handleZoomIn = () => {
    if (map) {
      const currentZoom = map.getZoom();
      map.setZoom(currentZoom + 1);
    }
  };

  const handleAddMaintenanceTask = async () => {
    if (!newMaintenanceTask.name.trim()) {
      toast({
        title: "Erreur",
        description: "Veuillez saisir le nom de la tâche de maintenance",
        status: "error",
        isClosable: true,
      });
      return;
    }

    try {
      await createMaintenanceTask(id, newMaintenanceTask);

      // Rafraîchir la liste des tâches de maintenance
      const tasksRes = await getMaintenanceTasks(id);
      setMaintenanceTasks(tasksRes.data || []);

      toast({
        title: "Succès",
        description: "Tâche de maintenance ajoutée avec succès",
        status: "success",
        isClosable: true,
      });

      onAddMaintenanceClose();
      setNewMaintenanceTask({ name: "", description: "", status: "ok" });
    } catch (error) {
      console.error('Error adding maintenance task:', error);
      toast({
        title: "Erreur",
        description: error.response?.data?.error || "Impossible d'ajouter la tâche de maintenance",
        status: "error",
        isClosable: true,
      });
    }
  };

  const handleAddMaterial = async () => {
    const isValid = newMaterialData.every(m => m.stock_id && m.quantite > 0);
    if (!isValid) {
      toast({
        title: "Erreur",
        description: "Veuillez sélectionner un item du stock valide pour chaque ligne",
        status: "error",
        isClosable: true,
      });
      return;
    }

    const invalidRow = newMaterialData.find(m => {
      const stockItem = stock.find(s => s.id?.toString() === m.stock_id?.toString());
      if (!stockItem) return true;
      if ((stockItem.quantite || 0) <= 0) return true;
      if (m.quantite > (stockItem.quantite || 0)) return true;
      return false;
    });

    if (invalidRow) {
      toast({
        title: "Erreur",
        description: "Stock introuvable ou quantité insuffisante pour un ou plusieurs éléments",
        status: "error",
        isClosable: true,
      });
      return;
    }

    try {
      // Loop through each item and assign from stock
      // Using a loop because assignStockToAmbulance handles one item at a time and performs transactions
      for (const material of newMaterialData) {
        await assignStockToAmbulance({
          stock_id: material.stock_id,
          ambulance_id: id,
          quantite: material.quantite
        });
      }

      // Rafraîchir la liste des matériels et du stock
      const [materialsRes, stockRes] = await Promise.all([
        getMaterielsByAmbulanceId(id),
        getAllStock()
      ]);

      setMaterials(materialsRes.data || []);
      setStock(stockRes.data || []);

      toast({
        title: "Succès",
        description: `${newMaterialData.length} élément(s) ajouté(s) avec succès`,
        status: "success",
        isClosable: true,
      });

      onAddMaterialClose();
      setNewMaterialData([{ type: "", item: "", quantite: 1, stock_id: "" }]);
    } catch (error) {
      console.error('Error adding materials:', error);
      toast({
        title: "Erreur",
        description: error.response?.data?.error || "Impossible d'ajouter les matériels",
        status: "error",
        isClosable: true,
      });
    }
  };

  const handleDeleteMaterial = async (materialId) => {
    try {
      await deleteMateriel(materialId);

      // Rafraîchir la liste des matériels
      const materialsRes = await getMaterielsByAmbulanceId(id);
      setMaterials(materialsRes.data || []);

      toast({
        title: "Succès",
        description: "Inventaire supprimé avec succès",
        status: "success",
        isClosable: true,
      });
    } catch (error) {
      console.error('Error deleting material:', error);
      toast({
        title: "Erreur",
        description: error.response?.data?.error || "Impossible de supprimer le Inventaire",
        status: "error",
        isClosable: true,
      });
    }
  };

  const addNewMaterialRow = () => {
    setNewMaterialData([...newMaterialData, { type: "", item: "", quantite: 1, stock_id: "" }]);
  };

  const removeMaterialRow = (index) => {
    if (newMaterialData.length > 1) {
      setNewMaterialData(newMaterialData.filter((_, i) => i !== index));
    }
  };

  const updateMaterialRow = (index, field, value) => {
    const updatedData = [...newMaterialData];
    updatedData[index][field] = value;

    if (field === 'type') {
      updatedData[index].item = ""; // Reset item when type changes
      updatedData[index].stock_id = "";
    } else if (field === 'stock_id') {
      // Find the item name from stock based on ID
      const selectedItem = stock.find(s => s.id.toString() === value.toString());
      if (selectedItem) {
        updatedData[index].item = selectedItem.item;
        updatedData[index].stock_id = selectedItem.id;
        // Limit quantity to available stock? Optional but good UX
        if (updatedData[index].quantite > selectedItem.quantite) {
          updatedData[index].quantite = selectedItem.quantite;
        }
      }
    }

    setNewMaterialData(updatedData);
  };

  const handleZoomOut = () => {
    if (map) {
      const currentZoom = map.getZoom();
      map.setZoom(currentZoom - 1);
    }
  };

  const handleIncrementMaterial = async (material) => {
    const materielId = material?.id ?? material?.materiel_id;
    if (!materielId) {
      toast({
        title: "Erreur",
        description: "ID matériel introuvable",
        status: "error",
        isClosable: true,
      });
      return;
    }
    try {
      await incrementMateriel(materielId);
      const materialsRes = await getMaterielsByAmbulanceId(id);
      setMaterials(materialsRes.data || []);
      toast({
        title: "Succès",
        description: "Quantité augmentée avec succès",
        status: "success",
        isClosable: true,
      });
    } catch (error) {
      toast({
        title: "Erreur",
        description: error.response?.data?.error || "Impossible d'augmenter la quantité",
        status: "error",
        isClosable: true,
      });
    }
  };

  const handleDecrementMaterial = async (material) => {
    if (material.quantite > 0) {
      const materielId = material?.id ?? material?.materiel_id;
      if (!materielId) {
        toast({
          title: "Erreur",
          description: "ID matériel introuvable",
          status: "error",
          isClosable: true,
        });
        return;
      }
      try {
        const response = await decrementMateriel(materielId);
        const materialsRes = await getMaterielsByAmbulanceId(id);
        setMaterials(materialsRes.data || []);

        if (response.data.deleted) {
          toast({
            title: "Succès",
            description: "Matériel supprimé car quantité = 0",
            status: "info",
            isClosable: true,
          });
        } else {
          toast({
            title: "Succès",
            description: "Quantité diminuée avec succès",
            status: "success",
            isClosable: true,
          });
        }
      } catch (error) {
        toast({
          title: "Erreur",
          description: error.response?.data?.error || "Impossible de diminuer la quantité",
          status: "error",
          isClosable: true,
        });
      }
    }
  };

  if (loading) {
    return <LoadingSpinner message="Chargement des détails du véhicule..." size="lg" fullHeight />;
  }

  if (!vehicle) {
    return <Box p="20px">Véhicule non trouvé</Box>;
  }

  /** Hauteur max des cartes inventaire : le défilement reste dans chaque carte, pas sur la page */
  const inventoryCardMaxH = "min(55vh, 440px)";

  const renderMaterialCategoryCard = (title, IconComponent, categoryKey, emptyMessage) => {
    const grouped = {};
    materials
      .filter((m) => getMaterielCategoryKey(m.type) === categoryKey)
      .forEach((m) => {
        const key = (m.item || "").toLowerCase().trim();
        if (!grouped[key]) {
          grouped[key] = { ...m };
        } else {
          grouped[key].quantite += m.quantite;
        }
      });
    const groupedMaterials = Object.values(grouped);
    const searchRaw = inventoryCardSearch[categoryKey] ?? "";
    const searchTerm = searchRaw.toLowerCase().trim();
    const filteredMaterials =
      searchTerm.length > 0
        ? groupedMaterials.filter((m) =>
            (m.item || "").toLowerCase().includes(searchTerm)
          )
        : groupedMaterials;

    return (
      <Card
        bg={bgCard}
        border="1px solid"
        borderColor={borderColor}
        borderRadius="12px"
        boxShadow="0px 4px 30px 0px rgba(0,0,0,0.06)"
        maxH={inventoryCardMaxH}
        display="flex"
        flexDirection="column"
        overflow="hidden"
      >
        <Box flexShrink={0} bg="#FCFCFC" borderBottom="1px solid" borderColor={borderColor} p="14px 20px">
          <HStack spacing="10px">
            <Box
              w="36px"
              h="36px"
              bg="#E3F2FD"
              border="1px solid"
              borderColor="rgba(69,156,233,0.2)"
              borderRadius="6px"
              display="flex"
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={IconComponent} w="20px" h="20px" color="#459CE9" />
            </Box>
            <Text fontSize="14px" fontWeight="500" color="#455879" flex="1">
              {title}
            </Text>
          </HStack>
        </Box>
        <CardBody p="14px" flex="1" minH={0} overflow="hidden" display="flex" flexDirection="column">
          <InputGroup size="sm" mb="10px" flexShrink={0}>
            <InputLeftElement pointerEvents="none" h="32px">
              <Icon as={MdSearch} color="gray.400" boxSize="16px" />
            </InputLeftElement>
            <Input
              pl="36px"
              h="32px"
              fontSize="13px"
              borderRadius="8px"
              borderColor={borderColor}
              bg={inventorySearchInputBg}
              placeholder="Rechercher…"
              value={searchRaw}
              onChange={(e) =>
                setInventoryCardSearch((prev) => ({
                  ...prev,
                  [categoryKey]: e.target.value,
                }))
              }
              aria-label={`Rechercher dans ${title}`}
            />
          </InputGroup>
          <Box flex="1" minH={0} overflowY="auto" overflowX="hidden">
            <VStack spacing="10px" align="stretch">
              {groupedMaterials.length > 0 ? (
                filteredMaterials.length > 0 ? (
                  filteredMaterials.map((material, index) => (
                    <Box
                      key={material.id || material.item || index}
                      bg="#FCFCFC"
                      border="1px solid"
                      borderColor={borderColor}
                      borderRadius="12px"
                      p="14px"
                      boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                    >
                      <Flex justify="space-between" align="center">
                        <VStack align="flex-start" spacing="5px" flex="1">
                          <Text fontSize="14px" fontWeight="500" color="#455879">
                            {material.item || title}
                          </Text>
                          <Text fontSize="12px" color="#656C7A">
                            Quantité: {material.quantite}
                          </Text>
                        </VStack>
                        {material.quantite > 0 ? (
                          <HStack>
                            <IconButton
                              icon={<MdRemove />}
                              aria-label="Diminuer"
                              size="sm"
                              colorScheme="gray"
                              variant="ghost"
                              onClick={() => handleDecrementMaterial(material)}
                            />
                            <Text>{material.quantite}</Text>
                            <IconButton
                              icon={<MdAdd />}
                              aria-label="Augmenter"
                              size="sm"
                              colorScheme="gray"
                              variant="ghost"
                              onClick={() => handleIncrementMaterial(material)}
                            />
                          </HStack>
                        ) : (
                          <IconButton
                            icon={<MdDelete />}
                            aria-label="Supprimer"
                            size="sm"
                            colorScheme="red"
                            variant="ghost"
                            onClick={() => handleDeleteMaterial(material.id)}
                          />
                        )}
                      </Flex>
                    </Box>
                  ))
                ) : (
                  <Box
                    bg="#FCFCFC"
                    border="1px solid"
                    borderColor={borderColor}
                    borderRadius="12px"
                    p="14px"
                    boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                  >
                    <Text fontSize="14px" color="#656C7A" textAlign="center">
                      Aucun résultat pour cette recherche
                    </Text>
                  </Box>
                )
              ) : (
                <Box
                  bg="#FCFCFC"
                  border="1px solid"
                  borderColor={borderColor}
                  borderRadius="12px"
                  p="14px"
                  boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                >
                  <Text fontSize="14px" color="#656C7A" textAlign="center">
                    {emptyMessage}
                  </Text>
                </Box>
              )}
            </VStack>
          </Box>
        </CardBody>
      </Card>
    );
  };

  return (
    <Box p="20px" pt="120px" bg={bgColor} minH="100vh">
      {/* Breadcrumb */}
      <HStack spacing="10px" mb="20px" align="center">
        <IconButton
          icon={<Icon as={MdArrowBack} />}
          variant="ghost"
          size="sm"
          onClick={() => navigate('/admin/vehicules')}
          aria-label="Retour"
          w="36px"
          h="36px"
          borderRadius="6px"
          _hover={{ bg: "gray.100" }}
        />
        <Text fontSize="14px" color="#656C7A" cursor="pointer" _hover={{ color: "#455879" }} onClick={() => navigate('/admin/vehicules')}>
          Ressources
        </Text>
        <Icon as={MdArrowForward} w="12px" h="12px" color="#656C7A" transform="rotate(-90deg)" />
        <Text fontSize="14px" color="#656C7A" cursor="pointer" _hover={{ color: "#455879" }} onClick={() => navigate('/admin/vehicules')}>
          Ambulances
        </Text>
        <Icon as={MdArrowForward} w="12px" h="12px" color="#656C7A" transform="rotate(-90deg)" />
        <Text fontSize="14px" color="#455879" fontWeight="600">
          Détails du véhicule
        </Text>
      </HStack>

      {/* Vehicle Header Card */}
      <Box bg={bgCard} borderRadius="6px" p="20px" border="1px solid" borderColor={borderColor} mb="20px">
        <Flex justify="space-between" align="flex-start" mb="14px">
          <HStack spacing="20px">
            <Box w="104px" h="104px" borderRadius="6px" bg="#E3F2FD" display="flex" alignItems="center" justifyContent="center">
              <Image
                src={ambulanceImg}
                alt={vehicle.immatriculation}
                w="80px"
                h="80px"
                objectFit="contain"
              />
            </Box>
            <VStack align="flex-start" spacing="4px">
              <Text fontSize="24px" fontWeight="600" color="#455879">
                {vehicle.immatriculation || `AMB-${vehicle.id}`}
              </Text>
              <HStack spacing="20px" flexWrap="wrap">
                <HStack spacing="5px">
                  <Icon as={MdDirectionsCar} w="16px" h="16px" color="#656C7A" />
                  <Text fontSize="14px" color="#455879">
                    {km ? `${parseInt(km).toLocaleString()} km` : "--- km"}
                  </Text>
                </HStack>
                <HStack spacing="5px">
                  <Icon as={MdCalendarToday} w="16px" h="16px" color="#656C7A" />
                  <Text fontSize="14px" color="#455879">
                    Dernier Entretien: {vehicle.dernier_entretien ? dayjs(vehicle.dernier_entretien).format("DD/MM/YYYY HH:mm") : "Non spécifié"}
                  </Text>
                </HStack>
                {ambulancier && (
                  <HStack spacing="5px">
                    <Avatar size="sm" name={`${ambulancier.nom} ${ambulancier.prenom}`} />
                    <Text fontSize="14px" color="#455879">
                      {ambulancier.nom} {ambulancier.prenom}
                    </Text>
                  </HStack>
                )}
              </HStack>
              {fuelLevel !== null && (
                <HStack spacing="10px" mt="10px" w="100%">
                  <Text fontSize="14px" color="#455879" minW="50px">Gasoil</Text>
                  <Progress
                    value={fuelLevel}
                    colorScheme={fuelLevel < 20 ? "red" : fuelLevel < 50 ? "yellow" : "green"}
                    flex="1"
                    h="8px"
                    borderRadius="4px"
                  />
                  <Text fontSize="14px" color="#455879" minW="40px">{fuelLevel}%</Text>
                  {fuelLevel < 20 && <Icon as={MdWarning} w="16px" h="16px" color="#F8285A" />}
                </HStack>
              )}
            </VStack>
          </HStack>
          <HStack spacing="10px">
            <Badge
              bg={getStatusBg(vehicle.statut)}
              color="white"
              borderRadius="20px"
              px="10px"
              py="6px"
              fontSize="12px"
              display="flex"
              alignItems="center"
              gap="6px"
            >
              <Box w="6px" h="6px" borderRadius="50%" bg="white" />
              {((vehicle.statut || "Disponible") + "").toUpperCase()}
            </Badge>
            <IconButton
              icon={<Icon as={MdMoreVert} />}
              variant="ghost"
              size="sm"
              aria-label="Actions"
            />
          </HStack>
        </Flex>

        {/* Tabs */}
        <HStack spacing="0" borderTop="1px solid" borderColor={borderColor} pt="10px">
          <Button
            variant="ghost"
            size="sm"
            borderRadius="6px"
            _hover={{ bg: "gray.100" }}
            bg={activeTab === "localisation" ? "gray.50" : "transparent"}
            onClick={() => setActiveTab("localisation")}
          >
            Localisation
          </Button>
          <Button
            variant="ghost"
            size="sm"
            borderRadius="6px"
            _hover={{ bg: "gray.100" }}
            bg={activeTab === "Inventaire" ? "gray.50" : "transparent"}
            onClick={() => setActiveTab("Inventaire")}
          >
            Inventaire
          </Button>
          <Button
            variant="ghost"
            size="sm"
            borderRadius="6px"
            _hover={{ bg: "gray.100" }}
            bg={activeTab === "Historique" ? "gray.50" : "transparent"}
            onClick={() => setActiveTab("Historique")}
          >
            Historique
          </Button>
          <Button
            variant="ghost"
            size="sm"
            borderRadius="6px"
            _hover={{ bg: "gray.100" }}
            bg={activeTab === "maintenance" ? "gray.50" : "transparent"}
            onClick={() => setActiveTab("maintenance")}
          >
            Maintenance
          </Button>
        </HStack>
      </Box>

      {/* Maintenance Tab Content */}
      {activeTab === "maintenance" && (
        <Box>
          {/* Header with search and filters */}
          <Box bg={bgCard} borderRadius="6px" p="20px" border="1px solid" borderColor={borderColor} mb="20px">
            <Flex justify="space-between" align="center" mb="20px">
              <Text fontSize="18px" fontWeight="600" color="#455879">
                Liste des Maintenances ({filteredTasks.length})
              </Text>
              <HStack spacing="10px">
                <InputGroup maxW="240px">
                  <InputLeftElement pointerEvents="none">
                    <Icon as={MdSearch} color="gray.400" />
                  </InputLeftElement>
                  <Input
                    placeholder="Recherche d'une maintenance..."
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                    bg="white"
                    borderRadius="md"
                  />
                </InputGroup>
                <Select
                  value={statusFilter}
                  onChange={(e) => {
                    setStatusFilter(e.target.value);
                    setCurrentPage(1);
                  }}
                  maxW="120px"
                  size="sm"
                  bg="white"
                >
                  <option value="all">Statut: Tous</option>
                  <option value="ok">Ok</option>
                  <option value="soon">Bientôt</option>
                  <option value="urgent">Urgent</option>
                </Select>
                <Select
                  value={sortBy}
                  onChange={(e) => {
                    setSortBy(e.target.value);
                    setCurrentPage(1);
                  }}
                  maxW="140px"
                  size="sm"
                  bg="white"
                >
                  <option value="latest">Trier par: Dernière</option>
                  <option value="oldest">Plus ancienne</option>
                  <option value="name">Nom</option>
                </Select>
                <HStack spacing="2">
                  <IconButton
                    icon={<MdGridView />}
                    aria-label="Vue grille"
                    size="sm"
                    variant={viewMode === "grid" ? "solid" : "outline"}
                    colorScheme={viewMode === "grid" ? "blue" : "gray"}
                    onClick={() => setViewMode("grid")}
                  />
                  <IconButton
                    icon={<MdList />}
                    aria-label="Vue liste"
                    size="sm"
                    variant={viewMode === "list" ? "solid" : "outline"}
                    colorScheme={viewMode === "list" ? "blue" : "gray"}
                    onClick={() => setViewMode("list")}
                  />
                  <IconButton
                    icon={<MdTableChart />}
                    aria-label="Vue tableau"
                    size="sm"
                    variant={viewMode === "table" ? "solid" : "outline"}
                    colorScheme={viewMode === "table" ? "blue" : "gray"}
                    onClick={() => setViewMode("table")}
                  />
                </HStack>
                <IconButton
                  icon={<MdRefresh />}
                  aria-label="Actualiser"
                  size="sm"
                  variant="outline"
                  onClick={() => window.location.reload()}
                />
                <IconButton
                  icon={<MdAdd />}
                  aria-label="Ajouter"
                  size="sm"
                  colorScheme="blue"
                  borderRadius="50%"
                  onClick={() => {
                    onAddMaintenanceOpen();
                  }}
                />
              </HStack>
            </Flex>
          </Box>

          {/* Maintenance Tasks Display */}
          {paginatedTasks.length > 0 ? (
            <>
              {viewMode === "table" ? (
                /* Table View */
                <Box
                  bg={bgCard}
                  borderRadius="12px"
                  border="1px solid"
                  borderColor={borderColor}
                  overflow="hidden"
                  mb="20px"
                >
                  <Table variant="simple">
                    <Thead>
                      <Tr>
                        <Th
                          bg="#FCFCFC"
                          borderColor={borderColor}
                          fontSize="14px"
                          fontWeight="600"
                          color="#455879"
                          cursor="pointer"
                          onClick={() => setSortBy(sortBy === "name_asc" ? "name_desc" : "name_asc")}
                          _hover={{ bg: "#F0F0F2" }}
                        >
                          <HStack spacing="4px">
                            <Text>Nom de la tâche</Text>
                            {sortBy === "name_asc" && <Text fontSize="10px">↑</Text>}
                            {sortBy === "name_desc" && <Text fontSize="10px">↓</Text>}
                          </HStack>
                        </Th>
                        <Th
                          bg="#FCFCFC"
                          borderColor={borderColor}
                          fontSize="14px"
                          fontWeight="600"
                          color="#455879"
                          cursor="pointer"
                          onClick={() => setSortBy(sortBy === "status_asc" ? "status_desc" : "status_asc")}
                          _hover={{ bg: "#F0F0F2" }}
                        >
                          <HStack spacing="4px">
                            <Text>Statut</Text>
                            {sortBy === "status_asc" && <Text fontSize="10px">↑</Text>}
                            {sortBy === "status_desc" && <Text fontSize="10px">↓</Text>}
                          </HStack>
                        </Th>
                        <Th
                          bg="#FCFCFC"
                          borderColor={borderColor}
                          fontSize="14px"
                          fontWeight="600"
                          color="#455879"
                          cursor="pointer"
                          onClick={() => setSortBy(sortBy === "date_asc" ? "date_desc" : "date_asc")}
                          _hover={{ bg: "#F0F0F2" }}
                        >
                          <HStack spacing="4px">
                            <Text>Échéance</Text>
                            {sortBy === "date_asc" && <Text fontSize="10px">↑</Text>}
                            {sortBy === "date_desc" && <Text fontSize="10px">↓</Text>}
                          </HStack>
                        </Th>
                        <Th bg="#FCFCFC" borderColor={borderColor} fontSize="14px" fontWeight="600" color="#455879">
                          Note
                        </Th>
                        <Th bg="#FCFCFC" borderColor={borderColor} fontSize="14px" fontWeight="600" color="#455879" textAlign="center">
                          Actions
                        </Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {paginatedTasks.map((task) => (
                        <Tr key={task.id} _hover={{ bg: "#FCFCFC" }}>
                          <Td borderColor={borderColor} fontSize="14px" fontWeight="500" color="#455879">
                            {task.name}
                          </Td>
                          <Td borderColor={borderColor}>
                            <Badge
                              bg={getStatusBg(task.status)}
                              color="white"
                              borderRadius="20px"
                              px="8px"
                              py="4px"
                              fontSize="11px"
                              display="flex"
                              alignItems="center"
                              gap="4px"
                              w="fit-content"
                            >
                              <Box w="5px" h="5px" borderRadius="50%" bg="white" />
                              {task.status === "ok" ? "Ok" : task.status === "soon" ? "Bientôt" : task.status === "urgent" ? "Urgent" : task.status}
                            </Badge>
                          </Td>
                          <Td borderColor={borderColor} fontSize="14px" color="#455879">
                            {task.next_due_date ? dayjs(task.next_due_date).format("DD/MM/YYYY") : "Non définie"}
                          </Td>
                          <Td borderColor={borderColor} fontSize="14px" color="#455879" maxW="200px">
                            <Text noOfLines={1}>
                              {task.notes || "-"}
                            </Text>
                          </Td>
                          <Td borderColor={borderColor} textAlign="center">
                            <HStack spacing="4px" justify="center">
                              {task.status !== "ok" && (
                                <Button
                                  size="xs"
                                  colorScheme="teal"
                                  variant="outline"
                                  onClick={() => handleStatusChange(task.id, "ok")}
                                  fontSize="11px"
                                >
                                  Ok
                                </Button>
                              )}
                              {task.status !== "soon" && (
                                <Button
                                  size="xs"
                                  colorScheme="yellow"
                                  variant="outline"
                                  onClick={() => handleStatusChange(task.id, "soon")}
                                  fontSize="11px"
                                >
                                  Bientôt
                                </Button>
                              )}
                              {task.status !== "urgent" && (
                                <Button
                                  size="xs"
                                  colorScheme="red"
                                  variant="outline"
                                  onClick={() => handleStatusChange(task.id, "urgent")}
                                  fontSize="11px"
                                >
                                  Urgent
                                </Button>
                              )}
                            </HStack>
                          </Td>
                        </Tr>
                      ))}
                    </Tbody>
                  </Table>
                </Box>
              ) : (
                /* Grid/List View */
                <SimpleGrid columns={{ base: 1, md: 2, lg: 3, xl: 4 }} spacing="20px" mb="20px">
                  {paginatedTasks.map((task) => (
                    <Card
                      key={task.id}
                      bg={bgCard}
                      border="1px solid"
                      borderColor={borderColor}
                      borderRadius="6px"
                      _hover={{ boxShadow: "md" }}
                      transition="all 0.2s"
                    >
                      <CardBody p="20px">
                        <VStack align="stretch" spacing="15px">
                          {/* Header with name and status */}
                          <Flex justify="space-between" align="start">
                            <Text fontSize="16px" fontWeight="600" color="#455879" flex="1">
                              {task.name}
                            </Text>
                            <Badge
                              bg={getStatusBg(task.status)}
                              color="white"
                              borderRadius="20px"
                              px="8px"
                              py="4px"
                              fontSize="11px"
                              display="flex"
                              alignItems="center"
                              gap="4px"
                            >
                              <Box w="5px" h="5px" borderRadius="50%" bg="white" />
                              {task.status === "ok" ? "Ok" : task.status === "soon" ? "Bientôt" : task.status === "urgent" ? "Urgent" : task.status}
                            </Badge>
                          </Flex>

                          {/* Due date */}
                          <HStack spacing="5px">
                            <Icon as={MdCalendarToday} w="16px" h="16px" color="#656C7A" />
                            <Text fontSize="14px" color="#455879">
                              Échéance: {task.next_due_date ? dayjs(task.next_due_date).format("DD/MM/YYYY") : "Non définie"}
                            </Text>
                          </HStack>

                          {/* Notes */}
                          {task.notes && (
                            <Box>
                              <Text fontSize="12px" color="#656C7A" mb="5px">Note</Text>
                              <Text fontSize="14px" color="#455879" noOfLines={2}>
                                {task.notes}
                              </Text>
                            </Box>
                          )}

                          {/* Status change buttons */}
                          <VStack align="stretch" spacing="10px" pt="10px" borderTop="1px solid" borderColor={borderColor}>
                            <Text fontSize="12px" color="#656C7A" fontWeight="500">
                              Changer le statut
                            </Text>
                            <HStack spacing="8px">
                              {task.status !== "ok" && (
                                <Button
                                  size="sm"
                                  colorScheme="teal"
                                  variant="outline"
                                  flex="1"
                                  onClick={() => handleStatusChange(task.id, "ok")}
                                  fontSize="12px"
                                >
                                  Ok
                                </Button>
                              )}
                              {task.status !== "soon" && (
                                <Button
                                  size="sm"
                                  colorScheme="yellow"
                                  variant="outline"
                                  flex="1"
                                  onClick={() => handleStatusChange(task.id, "soon")}
                                  fontSize="12px"
                                >
                                  Bientôt
                                </Button>
                              )}
                              {task.status !== "urgent" && (
                                <Button
                                  size="sm"
                                  colorScheme="red"
                                  variant="outline"
                                  flex="1"
                                  onClick={() => handleStatusChange(task.id, "urgent")}
                                  fontSize="12px"
                                >
                                  Urgent
                                </Button>
                              )}
                            </HStack>
                          </VStack>
                        </VStack>
                      </CardBody>
                    </Card>
                  ))}
                </SimpleGrid>
              )}

              {/* Pagination */}
              <Flex justify="space-between" align="center" p="14px" bg={bgCard} borderRadius="6px" border="1px solid" borderColor={borderColor}>
                <HStack spacing="10px">
                  <Text fontSize="14px" color="#656C7A">Afficher</Text>
                  <Select
                    value={itemsPerPage}
                    onChange={(e) => {
                      setItemsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                    w="60px"
                    size="sm"
                    bg="white"
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                  </Select>
                  <Text fontSize="14px" color="#656C7A">par page</Text>
                </HStack>
                <Text fontSize="14px" color="#656C7A">
                  {startIndex + 1} à {Math.min(endIndex, filteredTasks.length)} sur {filteredTasks.length}
                </Text>
                <HStack spacing="2">
                  <IconButton
                    icon={<MdChevronLeft />}
                    aria-label="Page précédente"
                    size="sm"
                    onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
                    isDisabled={currentPage === 1}
                  />
                  {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
                    let pageNum;
                    if (totalPages <= 5) {
                      pageNum = i + 1;
                    } else if (currentPage <= 3) {
                      pageNum = i + 1;
                    } else if (currentPage >= totalPages - 2) {
                      pageNum = totalPages - 4 + i;
                    } else {
                      pageNum = currentPage - 2 + i;
                    }
                    return (
                      <Button
                        key={pageNum}
                        size="sm"
                        variant={currentPage === pageNum ? "solid" : "outline"}
                        colorScheme={currentPage === pageNum ? "blue" : "gray"}
                        onClick={() => setCurrentPage(pageNum)}
                      >
                        {pageNum}
                      </Button>
                    );
                  })}
                  <IconButton
                    icon={<MdChevronRight />}
                    aria-label="Page suivante"
                    size="sm"
                    onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
                    isDisabled={currentPage === totalPages}
                  />
                </HStack>
              </Flex>
            </>
          ) : (
            <Box bg={bgCard} borderRadius="6px" p="40px" textAlign="center" border="1px solid" borderColor={borderColor}>
              <Text fontSize="16px" color="#656C7A">
                Aucune tâche de maintenance trouvée
              </Text>
            </Box>
          )}
        </Box>
      )}

      {/* Localisation Tab Content */}
      {activeTab === "localisation" && (
        <Box
          bg={bgCard}
          borderRadius="12px"
          border="1px solid"
          borderColor={borderColor}
          p="14px"
          boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
          position="relative"
          h="810px"
        >
          {vehicleLocation ? (
            <>
              {/* Google Maps */}
              <Box
                ref={mapRef}
                w="100%"
                h="100%"
                borderRadius="10px"
                overflow="hidden"
                position="relative"
              />

              {/* Zoom Controls */}
              <VStack
                position="absolute"
                top="16px"
                right="16px"
                spacing="0"
                zIndex={1000}
              >
                <IconButton
                  icon={<Text fontSize="16px">+</Text>}
                  aria-label="Zoom in"
                  size="sm"
                  bg="white"
                  border="1px solid"
                  borderColor={borderColor}
                  borderRadius="6px 6px 0 0"
                  boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                  onClick={handleZoomIn}
                  _hover={{ bg: "gray.50" }}
                />
                <IconButton
                  icon={<Text fontSize="16px">−</Text>}
                  aria-label="Zoom out"
                  size="sm"
                  bg="white"
                  border="1px solid"
                  borderColor="#F3F3F3"
                  borderTop="none"
                  borderRadius="0 0 6px 6px"
                  boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                  onClick={handleZoomOut}
                  _hover={{ bg: "gray.50" }}
                />
              </VStack>

              {/* Dispatch Panel */}
              <Box
                position="absolute"
                bottom="17px"
                right="16px"
                w="457px"
                bg="white"
                border="1px solid"
                borderColor={borderColor}
                borderRadius="12px"
                boxShadow="0px 4px 20px 0px rgba(0,0,0,0.06)"
                zIndex={1000}
              >
                {/* Header */}
                <Flex
                  justify="space-between"
                  align="center"
                  p="14px 20px"
                  bg="#FCFCFC"
                  borderBottom="1px solid"
                  borderColor={borderColor}
                  borderRadius="12px 12px 0 0"
                >
                  <Text fontSize="14px" fontWeight="500" color="#455879">
                    Localisation du Véhicule
                  </Text>
                  <IconButton
                    icon={<Text fontSize="12px">×</Text>}
                    aria-label="Fermer"
                    size="xs"
                    variant="ghost"
                    onClick={() => {
                      setDispatchDescription("");
                      if (marker && vehicleLocation) {
                        marker.setPosition(new window.google.maps.LatLng(vehicleLocation.lat, vehicleLocation.lng));
                        setSelectedLocation(vehicleLocation);
                      }
                    }}
                  />
                </Flex>

                {/* Content */}
                <VStack spacing="10px" align="stretch" p="20px 14px 14px 14px">
                  <VStack spacing="14px" align="stretch">
                    <Box>
                      <Text fontSize="13px" fontWeight="500" color="#455879" mb="5px">
                        Description du point de dispatch
                      </Text>
                      <Input
                        value={dispatchDescription}
                        onChange={(e) => setDispatchDescription(e.target.value)}
                        placeholder="Saisissez une description pour ce point"
                        bg="white"
                        border="1px solid"
                        borderColor={borderColor}
                        borderRadius="6px"
                        h="42px"
                        fontSize="13px"
                        boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                        _placeholder={{ color: "#656C7A" }}
                      />
                      <Text fontSize="11px" color="#656C7A" mt="5px">
                        Faites glisser le marqueur rouge ou cliquez sur la carte pour sélectionner le point de dispatch
                      </Text>
                    </Box>
                  </VStack>

                  <Flex justify="flex-end">
                    <Button
                      colorScheme="blue"
                      bg="#459CE9"
                      color="white"
                      size="sm"
                      h="36px"
                      px="10px"
                      borderRadius="6px"
                      onClick={handleDispatch}
                      isDisabled={!dispatchDescription.trim() || !selectedLocation}
                      boxShadow="0px 3px 4px 0px rgba(0,0,0,0.03)"
                    >
                      Dispatch
                    </Button>
                  </Flex>
                </VStack>
              </Box>
            </>
          ) : (
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              h="100%"
            >
              <Text fontSize="16px" color="#656C7A">
                {vehicle?.tracker_id
                  ? "Chargement de la localisation..."
                  : "Aucun tracker disponible pour ce véhicule"}
              </Text>
            </Box>
          )}
        </Box>
      )}

      {/* Inventaire Tab Content */}
      {activeTab === "Inventaire" && (
        <Box>
          {/* Header */}
          <Box bg={bgCard} borderRadius="12px" border="1px solid" borderColor={borderColor} mb="20px">
            <Flex justify="space-between" align="center" p="14px" borderBottom="1px solid" borderColor={borderColor}>
              <Text fontSize="14px" fontWeight="500" color="#455879">
                Inventaire
              </Text>
              <HStack spacing="10px">
                <IconButton
                  icon={<MdRefresh />}
                  aria-label="Actualiser"
                  size="sm"
                  variant="outline"
                  borderColor={borderColor}
                  onClick={async () => {
                    setLoadingInventory(true);
                    try {
                      const oxygenRes = await getOxygenBottles(id);
                      setOxygenBottles(oxygenRes.data || []);
                      const materialsRes = await getMaterielsByAmbulanceId(id);
                      setMaterials(materialsRes.data || []);
                      toast({
                        title: "Inventaire actualisé",
                        status: "success",
                        isClosable: true,
                      });
                    } catch (error) {
                      toast({
                        title: "Erreur",
                        description: "Impossible d'actualiser l'Inventaire",
                        status: "error",
                        isClosable: true,
                      });
                    } finally {
                      setLoadingInventory(false);
                    }
                  }}
                  isLoading={loadingInventory}
                />
                <IconButton
                  icon={<MdAdd />}
                  aria-label="Ajouter"
                  size="sm"
                  colorScheme="blue"
                  borderRadius="6px"
                  onClick={() => {
                    // Refresh stock when opening modal
                    getAllStock().then(res => setStock(res.data || [])).catch(console.error);
                    onAddMaterialOpen();
                  }}
                />
              </HStack>
            </Flex>

            {/* O₂ + Consommable + Dispositif + Pharmacie sur une ligne (≥ lg) */}
            <SimpleGrid columns={{ base: 1, sm: 2, lg: 4 }} spacing="10px" p="20px">
              {/* Oxygène Card */}
              <Card
                bg={bgCard}
                border="1px solid"
                borderColor={borderColor}
                borderRadius="12px"
                boxShadow="0px 4px 30px 0px rgba(0,0,0,0.06)"
                maxH={inventoryCardMaxH}
                display="flex"
                flexDirection="column"
                overflow="hidden"
              >
                <Box flexShrink={0} bg="#FCFCFC" borderBottom="1px solid" borderColor={borderColor} p="14px 20px">
                  <HStack spacing="10px">
                    <Box
                      w="36px"
                      h="36px"
                      bg="#E3F2FD"
                      border="1px solid"
                      borderColor="rgba(69,156,233,0.2)"
                      borderRadius="6px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdDirectionsCar} w="20px" h="20px" color="#459CE9" />
                    </Box>
                    <Text fontSize="14px" fontWeight="500" color="#455879" flex="1">
                      Oxygène
                    </Text>
                  </HStack>
                </Box>
                <CardBody p="14px" flex="1" minH={0} overflow="hidden" display="flex" flexDirection="column">
                  <InputGroup size="sm" mb="10px" flexShrink={0}>
                    <InputLeftElement pointerEvents="none" h="32px">
                      <Icon as={MdSearch} color="gray.400" boxSize="16px" />
                    </InputLeftElement>
                    <Input
                      pl="36px"
                      h="32px"
                      fontSize="13px"
                      borderRadius="8px"
                      borderColor={borderColor}
                      bg={inventorySearchInputBg}
                      placeholder="Rechercher…"
                      value={inventoryCardSearch.oxygene}
                      onChange={(e) =>
                        setInventoryCardSearch((prev) => ({
                          ...prev,
                          oxygene: e.target.value,
                        }))
                      }
                      aria-label="Rechercher dans Oxygène"
                    />
                  </InputGroup>
                  <Box flex="1" minH={0} overflowY="auto" overflowX="hidden">
                    <VStack spacing="10px" align="stretch">
                      {oxygenBottles.length > 0 ? (
                        (() => {
                          const oxyTerm = (inventoryCardSearch.oxygene ?? "").toLowerCase().trim();
                          const filteredBottles =
                            oxyTerm.length > 0
                              ? oxygenBottles.filter((bottle, i) => {
                                  const label = (
                                    bottle.name ||
                                    bottle.label ||
                                    `Bouteille ${i + 1}`
                                  ).toLowerCase();
                                  return label.includes(oxyTerm);
                                })
                              : oxygenBottles;
                          if (filteredBottles.length === 0) {
                            return (
                              <Box
                                bg="#FCFCFC"
                                border="1px solid"
                                borderColor={borderColor}
                                borderRadius="12px"
                                p="14px"
                                boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                              >
                                <Text fontSize="14px" color="#656C7A" textAlign="center">
                                  Aucun résultat pour cette recherche
                                </Text>
                              </Box>
                            );
                          }
                          const getProgressColor = (level) => {
                            if (level < 20) return "#F8285A";
                            if (level < 50) return "#F6B100";
                            return "#29BACD";
                          };
                          return filteredBottles.map((bottle) => {
                            const idx = oxygenBottles.indexOf(bottle);
                            const bottleName =
                              bottle.name ||
                              bottle.label ||
                              `Bouteille ${idx >= 0 ? idx + 1 : 1}`;
                            const currentLiters = bottle.current_liters || 0;
                            const capacityLiters = bottle.capacity_liters || 1;
                            const level =
                              capacityLiters > 0
                                ? Math.round((currentLiters / capacityLiters) * 100)
                                : 0;
                            return (
                              <Box
                                key={bottle.id || bottleName}
                                bg="#FCFCFC"
                                border="1px solid"
                                borderColor={borderColor}
                                borderRadius="12px"
                                p="14px"
                                boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                              >
                                <HStack spacing="5px" justify="space-between">
                                  <Text fontSize="14px" fontWeight="500" color="#455879" flex="1">
                                    {bottleName}
                                  </Text>
                                  <HStack
                                    bg="white"
                                    border="1px solid"
                                    borderColor={borderColor}
                                    borderRadius="100px"
                                    px="7px"
                                    py="4px"
                                    spacing="14px"
                                  >
                                    <Box position="relative" w="138px" h="8px">
                                      <Box
                                        position="absolute"
                                        w="100%"
                                        h="100%"
                                        bg="#F0F0F2"
                                        borderRadius="4px"
                                      />
                                      <Box
                                        position="absolute"
                                        left="0"
                                        top="0"
                                        w={`${level}%`}
                                        h="100%"
                                        bg={getProgressColor(level)}
                                        borderRadius="4px"
                                      />
                                    </Box>
                                    <Text fontSize="10px" fontWeight="500" color="#455879" minW="30px" textAlign="center">
                                      {level}%
                                    </Text>
                                  </HStack>
                                </HStack>
                              </Box>
                            );
                          });
                        })()
                      ) : (
                        <Box
                          bg="#FCFCFC"
                          border="1px solid"
                          borderColor={borderColor}
                          borderRadius="12px"
                          p="14px"
                          boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                        >
                          <Text fontSize="14px" color="#656C7A" textAlign="center">
                            Aucune bouteille d'oxygène
                          </Text>
                        </Box>
                      )}
                    </VStack>
                  </Box>
                </CardBody>
              </Card>

              {renderMaterialCategoryCard(
                "Consommable",
                MdMedicalServices,
                "consommable",
                "Aucun consommable"
              )}
              {renderMaterialCategoryCard(
                "Dispositif médical",
                MdLocalHospital,
                "dispositif",
                "Aucun dispositif médical"
              )}
              {renderMaterialCategoryCard(
                "Pharmacie",
                MdLocalPharmacy,
                "pharmacie",
                "Aucun élément de pharmacie"
              )}
            </SimpleGrid>
          </Box>
        </Box>
      )}

      {/* Historique Tab Content */}
      {activeTab === "Historique" && (
        <Box>
          {/* Header */}
          <Box bg={bgCard} borderRadius="12px" border="1px solid" borderColor={borderColor} mb="20px">
            <Flex justify="space-between" align="center" p="14px" borderBottom="1px solid" borderColor={borderColor}>
              <Text fontSize="14px" fontWeight="500" color="#455879">
                Historique
              </Text>
              <HStack spacing="10px">
                <IconButton
                  icon={<MdRefresh />}
                  aria-label="Actualiser"
                  size="sm"
                  variant="outline"
                  borderColor={borderColor}
                  onClick={loadHistoryData}
                  isLoading={loadingHistory}
                />
              </HStack>
            </Flex>

            {/* Historique Sections */}
            <Box p="20px">
              <SimpleGrid columns={{ base: 1, lg: 2 }} spacing="20px" align="start">
                {/* Historique de Consommation de Matériel */}
                <Box>
                  <HStack spacing="10px" mb="14px" >
                    <Box
                      w="36px"
                      h="36px"
                      bg="#E3F2FD"
                      border="1px solid"
                      borderColor="rgba(69,156,233,0.2)"
                      borderRadius="6px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdMedicalServices} w="20px" h="20px" color="#459CE9" />
                    </Box>
                    <Text fontSize="16px" fontWeight="600" color="#455879">
                      Historique de Consommation de Matériel
                    </Text>
                  </HStack>

                  {materialHistory.length > 0 ? (
                    <SimpleGrid columns={{ base: 1, xl: 1 }} spacing="10px">
                      {(() => {
                        const groupedMaterials = materialHistory.reduce((acc, item) => {
                          const missionId = item.mission_id || 'unknown';
                          if (!acc[missionId]) acc[missionId] = [];
                          acc[missionId].push(item);
                          return acc;
                        }, {});

                        return Object.entries(groupedMaterials).map(([missionId, items]) => (
                          <Card
                            key={missionId}
                            bg={bgCard}
                            border="1px solid"
                            borderColor={borderColor}
                            borderRadius="12px"
                            boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                          >
                            <CardBody p="14px">
                              <VStack align="flex-start" spacing="8px">
                                <HStack justify="space-between" w="100%">
                                  <Text fontSize="14px" fontWeight="600" color="#455879">
                                    Mission #{missionId}
                                  </Text>
                                  <Badge
                                    bg="#E3F2FD"
                                    color="#459CE9"
                                    borderRadius="20px"
                                    px="8px"
                                    py="2px"
                                    fontSize="11px"
                                  >
                                    {items.length} élément{items.length > 1 ? 's' : ''}
                                  </Badge>
                                </HStack>
                                <Divider />
                                <VStack align="flex-start" spacing="6px" w="100%">
                                  {items.map((item, index) => (
                                    <HStack key={item.id || index} justify="space-between" w="100%">
                                      <Text fontSize="13px" color="#455879">
                                        {item.item || item.material_name || 'Matériel'}
                                      </Text>
                                      <Badge
                                        bg="#F0F8FF"
                                        color="#459CE9"
                                        borderRadius="20px"
                                        px="6px"
                                        py="1px"
                                        fontSize="10px"
                                      >
                                        Qté: {item.quantite_utilisee || item.quantity || 0}
                                      </Badge>
                                    </HStack>
                                  ))}
                                </VStack>
                                {items[0]?.date && (
                                  <HStack spacing="5px">
                                    <Icon as={MdCalendarToday} w="14px" h="14px" color="#656C7A" />
                                    <Text fontSize="12px" color="#656C7A">
                                      {dayjs(items[0].date).format("DD/MM/YYYY HH:mm")}
                                    </Text>
                                  </HStack>
                                )}
                              </VStack>
                            </CardBody>
                          </Card>
                        ));
                      })()}
                    </SimpleGrid>
                  ) : (
                    <Box
                      bg="#FCFCFC"
                      border="1px solid"
                      borderColor={borderColor}
                      borderRadius="12px"
                      p="40px"
                      textAlign="center"
                      boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                    >
                      <Icon as={MdMedicalServices} w="48px" h="48px" color="#656C7A" mb="10px" />
                      <Text fontSize="14px" color="#656C7A" fontWeight="500">
                        Aucun historique de consommation
                      </Text>
                      <Text fontSize="12px" color="#656C7A" mt="5px">
                        Les consommations de matériel lors des missions apparaîtront ici
                      </Text>
                    </Box>
                  )}
                </Box>

                {/* Historique de Maintenance */}
                <Box>
                  <HStack spacing="10px" mb="14px">
                    <Box
                      w="36px"
                      h="36px"
                      bg="#FFF3E0"
                      border="1px solid"
                      borderColor="rgba(246,177,0,0.2)"
                      borderRadius="6px"
                      display="flex"
                      alignItems="center"
                      justifyContent="center"
                    >
                      <Icon as={MdDirectionsCar} w="20px" h="20px" color="#F6B100" />
                    </Box>
                    <Text fontSize="16px" fontWeight="600" color="#455879">
                      Historique de Maintenance
                    </Text>
                  </HStack>

                  {maintenanceHistory.length > 0 ? (
                    <VStack spacing="10px" align="stretch">
                      {maintenanceHistory.map((item, index) => (
                        <Box
                          key={item.id || index}
                          bg="#FCFCFC"
                          border="1px solid"
                          borderColor={borderColor}
                          borderRadius="12px"
                          p="14px"
                          boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                        >
                          <Flex justify="space-between" align="start">
                            <VStack align="flex-start" spacing="8px" flex="1">
                              <HStack justify="space-between" w="100%">
                                <Text fontSize="14px" fontWeight="600" color="#455879">
                                  {item.task_name || 'Maintenance'}
                                </Text>
                                <Badge
                                  bg={getStatusBg(item.status)}
                                  color="white"
                                  borderRadius="20px"
                                  px="8px"
                                  py="2px"
                                  fontSize="11px"
                                >
                                  {item.status === "ok" ? "Complété" : item.status === "soon" ? "En cours" : item.status === "urgent" ? "Urgent" : item.status}
                                </Badge>
                              </HStack>
                              <HStack spacing="5px">
                                <Icon as={MdCalendarToday} w="14px" h="14px" color="#656C7A" />
                                <Text fontSize="12px" color="#656C7A">
                                  {item.performed_at ? dayjs(item.performed_at).format("DD/MM/YYYY HH:mm") : "Date non spécifiée"}
                                </Text>
                              </HStack>
                              {item.technician && (
                                <HStack spacing="5px">
                                  <Icon as={MdPerson} w="14px" h="14px" color="#656C7A" />
                                  <Text fontSize="12px" color="#656C7A">
                                    Technicien: {item.technician}
                                  </Text>
                                </HStack>
                              )}
                              {item.notes && (
                                <Text fontSize="12px" color="#656C7A" mt="5px">
                                  {item.notes}
                                </Text>
                              )}
                            </VStack>
                          </Flex>
                        </Box>
                      ))}
                    </VStack>
                  ) : (
                    <Box
                      bg="#FCFCFC"
                      border="1px solid"
                      borderColor={borderColor}
                      borderRadius="12px"
                      p="40px"
                      textAlign="center"
                      boxShadow="0px 2px 3px 0px rgba(0,0,0,0.04)"
                    >
                      <Icon as={MdDirectionsCar} w="48px" h="48px" color="#656C7A" mb="10px" />
                      <Text fontSize="14px" color="#656C7A" fontWeight="500">
                        Aucun historique de maintenance
                      </Text>
                      <Text fontSize="12px" color="#656C7A" mt="5px">
                        Les maintenances effectuées sur ce véhicule apparaîtront ici
                      </Text>
                    </Box>
                  )}
                </Box>
              </SimpleGrid>
            </Box>
          </Box>
        </Box>
      )}

      {/* Add Material Unified Modal */}
      <Modal isOpen={isAddMaterialOpen} onClose={onAddMaterialClose} size="4xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="15px" maxW="900px">
          <ModalHeader borderBottom="1px solid" borderColor="gray.100">
            Ajouter du Inventaire
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody py={6}>
            <VStack spacing={4} align="stretch">
              <SimpleGrid columns={4} spacing={4} mb={2}>
                <Text fontWeight="bold" fontSize="sm" color="gray.600">Type</Text>
                <Text fontWeight="bold" fontSize="sm" color="gray.600">Inventaire</Text>
                <Text fontWeight="bold" fontSize="sm" color="gray.600">Quantité</Text>
                <Text></Text>
              </SimpleGrid>

              {newMaterialData.map((row, index) => (
                <SimpleGrid columns={4} spacing={4} key={index} alignItems="center">
                  <Select
                    placeholder="Type"
                    value={row.type}
                    onChange={(e) => updateMaterialRow(index, 'type', e.target.value)}
                    borderRadius="8px"
                  >
                    <option value="Consommable">Consommable</option>
                    <option value="Dispositif Médical">Dispositif Médical</option>
                    <option value="Pharmacie">Pharmacie</option>
                  </Select>

                  <Select
                    placeholder="Sélectionner l'item du stock"
                    value={row.stock_id}
                    onChange={(e) => updateMaterialRow(index, 'stock_id', e.target.value)}
                    isDisabled={!row.type}
                    borderRadius="8px"
                  >
                    {stock
                      .filter(s => normalizeType(s.type) === normalizeType(row.type) && s.quantite > 0)
                      .map(s => (
                        <option key={s.id} value={s.id}>
                          {s.item} (Dispo: {s.quantite})
                        </option>
                      ))}
                  </Select>

                  <NumberInput
                    min={1}
                    value={row.quantite}
                    onChange={(valueString) => updateMaterialRow(index, 'quantite', parseInt(valueString) || 1)}
                  >
                    <NumberInputField borderRadius="8px" />
                    <NumberInputStepper>
                      <NumberIncrementStepper />
                      <NumberDecrementStepper />
                    </NumberInputStepper>
                  </NumberInput>

                  <HStack>
                    <IconButton
                      icon={<MdDelete />}
                      colorScheme="red"
                      variant="ghost"
                      onClick={() => removeMaterialRow(index)}
                      isDisabled={newMaterialData.length === 1}
                      aria-label="Supprimer la ligne"
                    />
                  </HStack>
                </SimpleGrid>
              ))}

              <Button
                leftIcon={<MdAdd />}
                variant="outline"
                colorScheme="blue"
                size="sm"
                onClick={addNewMaterialRow}
                alignSelf="flex-start"
                mt={2}
                borderRadius="8px"
              >
                Ajouter une ligne
              </Button>
            </VStack>
          </ModalBody>

          <ModalFooter borderTop="1px solid" borderColor="gray.100">
            <Button variant="ghost" mr={3} onClick={onAddMaterialClose}>
              Annuler
            </Button>
            <Button colorScheme="blue" onClick={handleAddMaterial} px={8}>
              Enregistrer
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>

      {/* Modal for adding maintenance task */}
      <Modal isOpen={isAddMaintenanceOpen} onClose={onAddMaintenanceClose} size="lg" isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Ajouter une tâche de maintenance</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <VStack spacing={4} align="stretch">
              <FormControl isRequired>
                <FormLabel>Nom de la tâche</FormLabel>
                <Input
                  placeholder="Entrez le nom de la tâche de maintenance"
                  value={newMaintenanceTask.name}
                  onChange={(e) => setNewMaintenanceTask(prev => ({ ...prev, name: e.target.value }))}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Description (optionnel)</FormLabel>
                <Input
                  placeholder="Entrez une description détaillée"
                  value={newMaintenanceTask.description}
                  onChange={(e) => setNewMaintenanceTask(prev => ({ ...prev, description: e.target.value }))}
                />
              </FormControl>

              <FormControl>
                <FormLabel>Statut initial</FormLabel>
                <Select
                  value={newMaintenanceTask.status}
                  onChange={(e) => setNewMaintenanceTask(prev => ({ ...prev, status: e.target.value }))}
                >
                  <option value="ok">Ok</option>
                  <option value="soon">Bientôt</option>
                  <option value="urgent">Urgent</option>
                </Select>
              </FormControl>
            </VStack>
          </ModalBody>

          <ModalFooter>
            <Button variant="ghost" mr={3} onClick={onAddMaintenanceClose}>
              Annuler
            </Button>
            <Button colorScheme="blue" onClick={handleAddMaintenanceTask}>
              Ajouter la tâche
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

const VehicleDetailsWrapper = () => {
  return (
    <GoogleMapsLoader>
      <VehicleDetails />
    </GoogleMapsLoader>
  );
};


export default VehicleDetailsWrapper;
